<!--
* 组件名 : 内容页头部导航
* 开发者 : JY
*
* 参数: null
*
* 事件:  null
*
-->

<template>
  <div id="navbar" class="themes" v-if="isShow" ref="navbar">
    <v-btn class-name="menu-open" @btnClick="updateIsShowAside">
      <v-icon>menu</v-icon><span>{{ $TL.nav }}</span>
    </v-btn>

    <span class="fixed-episode-title">{{ episode }}</span>
    <div class="head-operation">
      <font-zawgyi v-if="$P.my" />
      <font-adjust />
      <globalBackgroundAudio />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import fontAdjust from "./components/font-adjust/index.vue";
import globalBackgroundAudio from "@/components/global-background-audio/index.vue";
import fontZawgyi from "@/components/font-zawgyi/index.vue";

export default {
  name: "v-navbar",
  data() {
    return {
      isShow: true,
      episode: "",
    };
  },
  components: {
    fontAdjust,
    globalBackgroundAudio,
    fontZawgyi,
  },

  created() {
    this.update_route({ name: this.$route.name });

    this.$P.$on("route_before_change", (payload) => {
      this.update_route(payload);
      $(this.$refs.navbar).removeAttr("style");
    });

    //  页面动画执行完显示 navbar
    this.$P.$on("page-change-started", () => {
      this.admission_animate();
      this.disabled_font_fn();
    });
  },
  mounted() {
    this.admission_animate();
    this.disabled_font_fn();
    window.addEventListener("scroll", this.update_navbar_themes);
  },
  methods: {
    ...mapMutations("global", ["updateIsShowAside"]),

    //  判断首屏不显示悬浮导航条，更新章节的 episode
    update_route({ name, from }) {
      this.$AsideRoute.map((item, i) => {
        //  更新章节 episode
        if (name === item.slug) {
          this.episode = item.episode;
        }
      });

      if (from && from.name === "home") {
        setTimeout(() => {
          this.isShow = true;
        }, 1000);
      } else {
        //  首屏不显示悬浮导航条
        this.isShow = name === "home" ? false : true;
      }
    },
    update_navbar_themes() {
      let update = () => {
        if ($(window).scrollTop() > window.innerHeight + 40) {
          this.$refs.navbar.classList.remove("themes");
        } else {
          this.$refs.navbar.classList.add("themes");
        }
      };

      window.requestAnimationFrame(update);
    },
    /**
     * 入场动画
     */
    admission_animate() {
      $(this.$refs.navbar)
        .stop()
        .css({ opacity: 0 })
        .velocity(
          {
            opacity: 1,
            top: 0,
          },
          { duration: 1000, easing: "easeInOutQuart" }
        );
    },

    /**
     * 部分页面禁用文字放大缩小功能
     */
    disabled_font_fn() {
      if ($(".set-font-size").length < 1) {
        $(".font-add-btn").attr("disabled", "disabled");
      } else {
        $(".font-add-btn").removeAttr("disabled");
      }
    },
  },
  beforeDestroy() {
    this.$P.$off("route_before_change");
    window.removeEventListener("scroll", this.update_navbar_themes, false);
  },
};
</script>

<style lang="scss">
#navbar {
  width: 100%;
  height: 54px;
  background: rgba($color-white, 0.82);
  backdrop-filter: blur(8px);
  box-shadow: 0 3px 6px rgba($color-black, 0.1);
  padding: 7px 30px;
  @include flex(center, space-between);
  position: fixed;
  left: 0;
  top: -30px;
  z-index: 990;
  opacity: 0;
  will-change: transform;
  //  IE11
  @media all and (-ms-high-contrast: none) {
    background: rgba($color-white, 0.96);
  }

  .v-btn {
    padding: 0;
  }

  .menu-open {
    i {
      font-size: 25px;
    }
    span {
      font-size: 16px;
    }
  }

  .head-operation {
    @include flex();
  }

  @media (max-width: $lx-min) {
    .fixed-episode-title {
      font-size: 14px;
    }
  }
}

@mixin tglStyle($color) {
  .tgl {
    span {
      border-color: $color;

      &::after {
        background-color: $color;
      }

      &::before {
        color: $color;
      }
    }
  }
}
//  处理各页面首屏导航条样式
body {
  &[data-slug="introduction"],
  &[data-slug="background-to-Almighty-God-s-work"],
  &[data-slug="Son-of-man-begins-speaking-in-house-churches"],
  &[data-slug="six-trials-of-God-s-judgment-work"],
  &[data-slug="God-incarnate-and-man-used-by-God"],
  &[data-slug="spread-of-kingdom-gospel"],
  &[data-slug="the-word-appears-in-the-flesh"] {
    #navbar {
      transition: background 0.45s ease;

      &.themes {
        background: transparent;
        box-shadow: none;
        backdrop-filter: none;

        .fixed-episode-title {
          opacity: 0;
        }

        @include tglStyle(#3a3a3a);
      }
    }
  }
  &[data-slug="introduction"] {
    #navbar.themes {
      button,
      span,
      i {
        color: $color-white !important;
      }

      @include tglStyle(#fff);
    }
  }
  &[data-slug="conclusion"] {
    .fixed-episode-title {
      visibility: hidden;
    }
  }

  section.home .home-nav {
    @include tglStyle(#fff);
  }

  &.latin {
    #navbar .fixed-episode-title {
      font-size: 14px;
    }
  }
}
</style>
